module.exports = __webpack_public_path__ + "img/call.9b8dde2b.svg";